import React from 'react'
import { LoadingOverlay, Modal, ScrollArea, Table, Text } from "@mantine/core"
import { useMatchPriorities, usePricingVersionCache } from '../../../../../hooks/global-job-matching'
import { useParams } from 'react-router'

type MatchPrioritiesModalProps = {
  opened: boolean
  onClose: () => void
}

export const MatchPrioritiesModal = ({ opened, onClose }: MatchPrioritiesModalProps) => {
  const params = useParams<{ id: string}>()
  const version = usePricingVersionCache(params.id)
  const { data, isLoading } = useMatchPriorities(params.id)
  const rows = data?.matchPriorities?.map((mp) => (
    <Table.Tr key={mp.id}>
      <Table.Td>{mp.org_job_code}</Table.Td>
      <Table.Td>{mp.org_job_code_key}</Table.Td>
      <Table.Td>{mp.survey_job_code}</Table.Td>
      <Table.Td>{mp.survey_code}</Table.Td>
      <Table.Td>{mp.match_priority}</Table.Td>
    </Table.Tr>
  ));

  return (
    <Modal title='Match Priorities' size='75vw' opened={opened} onClose={onClose}>
      <Text size='xl'>{version?.metadata?.filename}</Text>
      <LoadingOverlay visible={isLoading} />
      <ScrollArea p='sm'>
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Org Job Code</Table.Th>
              <Table.Th>Org Job Code Key</Table.Th>
              <Table.Th>Survey Job Code</Table.Th>
              <Table.Th>Survey Code</Table.Th>
              <Table.Th>Match Priority</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>{rows}</Table.Tbody>
        </Table>
      </ScrollArea>
    </Modal>
  )
}
